import { PropsWithChildren } from "react";
import styled from "styled-components";

import { FlexSpan, Icon, Message as UIMessage, RadioGroup, Description as DescriptionUI, Message } from "@evergis/ui";

import { TextInfoContainer } from "../../../styled";

export const ResultPreviewObjectCounterTitle = styled(DescriptionUI)`
  margin: 0.25rem 0 0;
`;

export const ResultPreviewObjectCounter = styled.div`
  padding: 0.75rem 1rem;
  box-sizing: border-box;
  background: rgba(0, 0, 0, 0.06);
  mix-blend-mode: normal;
  opacity: 0.6;
  border-radius: ${({ theme: { borderRadius } }) => borderRadius.smallest};
  width: 10rem;
`;

export const ResultPreviewContainer = styled.div`
  display: flex;
  height: 5.625rem;
  align-items: center;
  justify-content: space-between;
`;

export const ResultPreviewWrapper = styled.div`
  margin-bottom: 2.5rem;

  ${TextInfoContainer} {
    width: 100%;
  }
`;

export const CopyTaskMessage = styled(DescriptionUI)<{ success?: boolean; error?: boolean }>`
  margin: 0;
  color: ${({ success, error, theme }) => {
    if (success) {
      return theme.message.color.success;
    }

    if (error) {
      return theme.message.color.error;
    }
  }};
`;

export const CopyTaskMessageContainer = styled(Message)`
  display: flex;
  align-items: center;

  ${Icon} {
    margin-right: 1.5rem;
  }
`;

export const AttributeWarning = styled(DescriptionUI)`
  color: ${({ theme }) => theme.message.color.warning};
`;

export const AttributeItemIcon = styled(FlexSpan)`
  margin-right: 1rem;
  margin-top: 18px;
`;

export const AttributeItemCol = styled(FlexSpan)`
  align-items: center;
`;

export const AttributeItemRightCol = styled(AttributeItemCol)`
  margin-left: auto;
`;

export const AttributeItem = styled.div`
  background: white;
  display: flex;
  align-items: center;
  height: 90px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);
  border-radius: ${({ theme: { borderRadius } }) => borderRadius.smallest};
  padding: 0 1.5rem;
  box-sizing: border-box;

  &:not(:last-child) {
    margin-bottom: 0.5rem;
  }
`;

export const AttributesBlockContainer = styled.span`
  display: flex;
  background-color: rgba(0, 0, 0, 0.04);
  padding: 2rem 0;
  box-sizing: border-box;
  width: 100%;
  justify-content: center;
  position: relative;
  height: fit-content;
`;

export const TransferIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 18.75rem;
  height: 3rem;
  min-height: 3rem;

  ${Icon} {
    color: ${({ theme }) => theme.palette.textDisabled};
    transform: rotate(-90deg);
  }
`;

export const WizardWrapper = styled.div`
  margin-top: 2rem;
`;

export const CopySwitchLabel = styled.div<{ active?: boolean }>`
  color: ${({ theme, active }) => active && theme.palette.primary};
  cursor: pointer;

  &:hover {
    color: ${({ theme }) => theme.palette.primary};
  }
`;

export const CopySwitchWrapper = styled.div`
  margin: 0 1rem;
`;

export const CopySwitchContainer = styled.div<{ hidden?: boolean }>`
  visibility: ${({ hidden }) => hidden && "hidden"};
  display: flex;
  align-items: center;
`;

export const LabelContainer = styled.div`
  margin-left: 1em;
`;

export const Description = styled.div`
  font: ${({ theme: { fonts } }) => fonts.small};
`;

export const LayerCopyOptionsContainer = styled(UIMessage)<{ disabled?: boolean }>`
  display: flex;
  align-items: center;
  margin-top: 2.25rem;

  ${LabelContainer} {
    color: ${({ disabled, success, theme: { palette } }) =>
      disabled ? palette.textDisabled : success ? palette.primary : palette.textPrimary};
  }

  ${Description} {
    color: ${({ disabled, success, theme: { palette } }) =>
      disabled || !success ? palette.textDisabled : palette.primary};
  }
`;

export const LayerCopyFilteredOptionsContainer = styled.div`
  margin-top: 2.25rem;
`;

export const OptionsRadioGroup = styled(RadioGroup)<PropsWithChildren<unknown>>`
  display: flex;
  flex-direction: column;
`;

export const OptionsRadioContainer = styled.div`
  margin-bottom: 1rem;
`;
